<template>
    <div class="page_content" aria-label="Program Guide Page Content">
      <div class="row page-heading">
        <div class="col-7 input module_heading">
          <span class="module_icon icon-stream"></span>
		  <label class="head_txt module_type_name ace_sec_hd">{{stream.title}}</label>
        </div>
        <div class="col-5 right-container">
          <stream-header :uuid="uuid" active="category"></stream-header>
        </div>
      </div>
	  <div class="page-content">
		    <stream-menu :uuid="uuid"></stream-menu>

  			<div class="col-11 dasboard-left-section">
  				<div class="program-guide-section">
				  <div class="heading ace_sec_txt">Program Guides</div>
				  <ul class="program-guide-row">

					<li v-for="pg in programGuides" class="program-guide-column ace_sec_txt" v-if="pg.title !== 'Overall'">

						<b-link target="_blank" :href="pg.externalURL">
							<span class="inner-section">
								<span class="thumbnail"></span>
								<span class="title">{{pg.title}}</span>
							</span>
						</b-link>

					</li>
				  </ul>

  				</div>
  			</div>
        <div class="col-11 dasboard-left-section" v-if="!isProgramGuideAvailable">
          <div class="course-description col-12">
            <b-jumbotron>
              <h4 class="text-center">Program Guide View is currently not available.</h4>
              <p class="text-center ace_sec_txt">Please reach out to your institutional admin to unlock the Program Guide View.</p>
            </b-jumbotron>
          </div>
        </div>
	   </div>
  </div>
</template>

<script>
import '../../../assets/module/css/employer/employerHome.min.css'
import { mapState, mapActions } from 'vuex'
import StreamMenu from './StreamMenu'
import StreamHeader from './StreamHeader'

export default {
  name: 'streamReport',
  props: ['uuid'],
  components: {
    StreamMenu,
    StreamHeader
  },
  data: () => {
    return {
    }
  },

  mounted () {
    this.loadStream()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadStreamDetail',
      'loadLogDashboardActivity'
    ]),

    loadStream () {
      this.loadLogDashboardActivity({action: 'viewStreamProgramGuideView', page: 'streamProgressView', link: '', entityUuid: this.uuid})
      this.loadStreamDetail(this.uuid)
    }
  },

  computed: {
    ...mapState({
      'stream': state => state.stream.stream
    }),
    programGuides () {
      if (this.stream && this.stream.programGuides && this.stream.programGuides.length > 1) {
        return this.stream.programGuides
      } else {
        return []
      }
    },
    isProgramGuideAvailable () {
      if (this.stream && this.stream.programGuides && this.stream.programGuides.length > 1) {
        return true
      } else {
        return false
      }
    }
  },

  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/app/stream/components/ProgramGuide.vue